import { render, staticRenderFns } from "./PickupDetails.vue?vue&type=template&id=54340030&scoped=true"
import script from "./PickupDetails.vue?vue&type=script&lang=ts"
export * from "./PickupDetails.vue?vue&type=script&lang=ts"
import style0 from "./PickupDetails.vue?vue&type=style&index=0&id=54340030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54340030",
  null
  
)

export default component.exports